/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * W3C VC1.1 specific properties.
 */
export interface Credential11 {
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    expirationDate?: Date;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    holder?: string;
    /** The URI of a credential. */
    id: string;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    issuanceDate: Date;
    /** The URI of the credential issuer. */
    issuer: string;
    proof: Truvity.Credential11Proof;
    /** A list of credential types. [Terminology](https://www.w3.org/TR/vc-data-model/#dfn-type). */
    type: string[];
}
